export default __webpack_public_path__ + "media/images/preview-image-39fa851038e19a4cb47ca3bba639b5b5.jpg";